// Blog image lightbox (no dependencies)
(function () {
  const isBlog = document.documentElement && /(^|\/)(blogs?|articles?)(\/|$)/.test(window.location.pathname);
  if (!isBlog) return;

  // Build overlay once
  const backdrop = document.createElement('div');
  backdrop.className = 'blx-backdrop';
  backdrop.setAttribute('aria-hidden', 'true');
  backdrop.innerHTML = `
    <div class="blx-wrap">
      <img class="blx-img" alt="">
      <button class="blx-close" aria-label="Close"><span class="blx-btn-icon">×</span></button>
      <button class="blx-prev" aria-label="Previous"><span class="blx-btn-icon">‹</span></button>
      <button class="blx-next" aria-label="Next"><span class="blx-btn-icon">›</span></button>
    </div>
  `;
  document.body.appendChild(backdrop);

  const imgEl = backdrop.querySelector('.blx-img');
  const btnClose = backdrop.querySelector('.blx-close');
  const btnPrev = backdrop.querySelector('.blx-prev');
  const btnNext = backdrop.querySelector('.blx-next');

  // Find blog content images (works across most themes, including Baseline)
  const candidates = Array.from(document.querySelectorAll(
    '.rte img, .prose img, article img, [data-article] img, [data-article-body] img'
  )).filter(el => el.width > 0 && el.height > 0);

  if (candidates.length === 0) return;

  // Make them look clickable
  candidates.forEach(el => el.classList.add('blx-zoomable'));

  // Resolve a higher-res Shopify src from an <img> src
  function upscaleShopify(src, target = 2048) {
    try {
      // Handle //cdn.shopify.com URLs with size segment like _600x
      const url = new URL(src, window.location.origin);
      const parts = url.pathname.split('.');
      // Insert _{width}x before extension (Shopify convention)
      const last = parts.pop();
      // If a size like _{n}x exists already, replace it
      const sized = parts.join('.').replace(/_(\d+)x$/, '');
      url.pathname = `${sized}_${target}x.${last}`;
      return url.toString();
    } catch {
      // Fallback: just return original
      return src;
    }
  }

  // Build gallery state
  let index = 0;
  const sources = candidates.map(el => {
    const src = el.getAttribute('data-src') || el.getAttribute('data-original') || el.currentSrc || el.src;
    return {
      thumb: src,
      large: upscaleShopify(src, 2048),
      alt: el.getAttribute('alt') || ''
    };
  });

  function openAt(i) {
    index = (i + sources.length) % sources.length;
    const item = sources[index];
    imgEl.src = ''; // reset to avoid flashing old image
    imgEl.alt = item.alt;
    imgEl.src = item.large;
    backdrop.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function close() {
    backdrop.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }
  function next() { openAt(index + 1); }
  function prev() { openAt(index - 1); }

  // Wire up triggers
  candidates.forEach((el, i) => {
    el.addEventListener('click', (e) => {
      // Don’t hijack if the image is already inside a link to somewhere else
      if (el.closest('a')) return;
      e.preventDefault();
      openAt(i);
    });
  });

  // Controls
  btnClose.addEventListener('click', close);
  btnNext.addEventListener('click', next);
  btnPrev.addEventListener('click', prev);
  backdrop.addEventListener('click', (e) => {
    // click outside the image closes
    if (!e.target.closest('.blx-wrap')) close();
  });
  document.addEventListener('keydown', (e) => {
    if (backdrop.getAttribute('aria-hidden') === 'true') return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowRight') next();
    if (e.key === 'ArrowLeft') prev();
  });
})();
